import { createContext } from 'react';

import { User } from '@totem/components/users/container/types';
import { OrganizationHierarchy } from '@totem/types/organization';
import {
  DataAccessGroup,
  DataAccessPermissionUpdate,
  EligibleSecurityGroup,
  SecurityGroup,
} from '@totem/types/user';

interface Context {
  userId: string;
  user: User;
  userLoading: boolean;
  securityGroups: SecurityGroup[];
  securityGroupsLoading: boolean;
  eligibleGroups: EligibleSecurityGroup[];
  orgHierarchy: OrganizationHierarchy;
  dataPermissions: DataAccessGroup[];
  allDataPermissions: DataAccessGroup[];
  dataPermissionsHierarchy: OrganizationHierarchy;
  dataLoading: boolean;
  onRefresh: () => void;
  onSecurityGroupAdd: (group: SecurityGroup) => void;
  onSecurityGroupRemove: (group: SecurityGroup) => void;
  onDataPermissionUpdate: (update: DataAccessPermissionUpdate) => void;
}

export default createContext<Context>({
  userId: '',
  user: null,
  userLoading: false,
  securityGroups: [],
  securityGroupsLoading: false,
  eligibleGroups: [],
  orgHierarchy: null,
  dataPermissions: [],
  allDataPermissions: [],
  dataPermissionsHierarchy: null,
  dataLoading: false,
  onRefresh: () => {},
  onSecurityGroupAdd: () => {},
  onSecurityGroupRemove: () => {},
  onDataPermissionUpdate: () => {},
});
